/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 公司筛选
 */

import commonStyles from '../../common/common.scss';
import styles from './searchForm.scss';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Form, Select } from 'antd';
import {isNotEmpty} from '../../../../../utils/util';
import {debounce} from '../../../../../utils/debounce';
import {getOptions} from '../../../../../services/financialPicture';
const FormItem = Form.Item;
const Option = Select.Option;

class FilterSearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            itemOptions: {}
        };
    }

    componentDidMount() {
        if (isNotEmpty(this.props.item)) {
            this.getOptions();
            this.onSubmit();
        }
    }

    componentWillUnmount() {
        this.syncSearch.cancel();
    }

    getOptions = () => {
        getOptions({
            companyCode: this.props.item.companyCode
        }).then(data => {
            this.setState({
                itemOptions: data || {}
            });
        });
    };

    syncSearch = debounce(() => {
        this.onSubmit();
    }, 300);

    onSubmit = (e) => {
        e && e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                onSearch && onSearch(values);
            }
        });
    };

    render() {
        const { item, options, getPopupContainer } = this.props;
        const { getFieldDecorator } = this.props.form;
        const { itemOptions } = this.state;
        const { reportYear = [], reportDateType = [], reportType = [] } = itemOptions;
        const { riskFakeTypes = [] } = options;

        return (
            <div className={classNames('search-bar', commonStyles.searchBar, styles.modalSearch)}>
                <Form hideRequiredMark layout="inline" onSubmit={this.onSubmit}>
                    <FormItem>
                        {getFieldDecorator('year', {
                            initialValue: item.reportYear
                        })(
                            <Select
                                placeholder="年份"
                                size="default"
                                getPopupContainer={getPopupContainer}
                                onChange={this.syncSearch}
                            >
                                {reportYear.map(d => (
                                    <Option key={d} value={d}>
                                        {d}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('reportDateType', {
                            initialValue: item.reportDateType
                        })(
                            <Select
                                placeholder="时间类型"
                                size="default"
                                getPopupContainer={getPopupContainer}
                                onChange={this.syncSearch}
                            >
                                {reportDateType.map(d => (
                                    <Option key={d.key} value={d.key}>
                                        {d.value}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </FormItem>
                    <FormItem className="hide">
                        {getFieldDecorator('reportType', {
                            initialValue: item.reportType
                        })(
                            <Select
                                placeholder="报表类型"
                                size="default"
                                getPopupContainer={getPopupContainer}
                                onChange={this.syncSearch}
                            >
                                {reportType.map(d => (
                                    <Option key={d.key} value={d.key}>
                                        {d.value}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('anaType', {
                            initialValue: riskFakeTypes[0] && riskFakeTypes[0].key
                        })(
                            <Select
                                placeholder="风险类型"
                                size="default"
                                getPopupContainer={getPopupContainer}
                                onChange={this.syncSearch}
                            >
                                {riskFakeTypes.map(d => (
                                    <Option key={d.key} value={d.key}>
                                        {d.value}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </FormItem>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(FilterSearchForm));



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/company/overviewModal/SearchForm.jsx